import dayjs from "dayjs";

// 1. Move Day.js Locales and AntD/DateFns imports to the top
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/fr';
import 'dayjs/locale/hi';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/vi';
import 'dayjs/locale/pt';
import 'dayjs/locale/hr';
import 'dayjs/locale/da';
import 'dayjs/locale/fa';
import 'dayjs/locale/ru';

import enUSAntd from "antd/locale/en_US";
import frFR from "antd/locale/fr_FR";
import hiIN from "antd/locale/hi_IN";
import deDE from "antd/locale/de_DE";
import esES from "antd/locale/es_ES";
import zhCNAntd from "antd/locale/zh_CN";
import ruRU from "antd/locale/ru_RU";
import ptPT from "antd/locale/pt_PT";
import viVN from "antd/locale/vi_VN";
import daDK from "antd/locale/da_DK";
import hrHR from "antd/locale/hr_HR";
import faIRAntd from "antd/locale/fa_IR";

import { enUS, fr, hi, de, es, zhCN, ru, pt, vi, da, hr, faIR } from "date-fns/locale";

import { DEFAULT_LANGUAGE, LANGUAGES, SUPPORTED_LANGUAGES } from "./languages";
import i18n from "./i18n";

export const DATE_FNS_LOCALES = {
  [LANGUAGES.EN]: enUS,
  [LANGUAGES.FR]: fr,
  [LANGUAGES.HI]: hi,
  [LANGUAGES.DE]: de,
  [LANGUAGES.ES]: es,
  [LANGUAGES.VI]: vi,
  [LANGUAGES.PT]: pt,
  [LANGUAGES.HR]: hr,
  [LANGUAGES.DA]: da,
  [LANGUAGES.FA]: faIR,
  [LANGUAGES.RU]: ru,
  [LANGUAGES.ZH_CN]: zhCN,
  [LANGUAGES.HMN]: enUS,
};

export const ANT_D_LOCALES = {
  [LANGUAGES.EN]: enUSAntd,
  [LANGUAGES.FR]: frFR,
  [LANGUAGES.HI]: hiIN,
  [LANGUAGES.DE]: deDE,
  [LANGUAGES.ES]: esES,
  [LANGUAGES.VI]: viVN,
  [LANGUAGES.PT]: ptPT,
  [LANGUAGES.HR]: hrHR,
  [LANGUAGES.DA]: daDK,
  [LANGUAGES.FA]: faIRAntd,
  [LANGUAGES.RU]: ruRU,
  [LANGUAGES.ZH_CN]: zhCNAntd,
  [LANGUAGES.HMN]: enUSAntd,
};

const DAYJS_LOCALE_MAP = {
  en: "en",
  fr: "fr",
  hi: "hi",
  de: "de",
  es: "es",
  vi: "vi",
  pt: "pt",
  hr: "hr",
  da: "da",
  fa: "fa",
  ru: "ru",
  "zh-CN": "zh-cn",
};

export const getCurrentLanguage = () => i18n.language || DEFAULT_LANGUAGE;
export const getLanguages = () => SUPPORTED_LANGUAGES;
const normalizeLang = (lang) => lang?.split("-")[0] || DEFAULT_LANGUAGE;

export const changeLanguage = (lang) => {
  const isValid = SUPPORTED_LANGUAGES.some(l => l.code === lang);
  const finalLang = isValid ? lang : DEFAULT_LANGUAGE;
  localStorage.setItem("app_language", finalLang);
  i18n.changeLanguage(finalLang);
  window.dispatchEvent(new CustomEvent("app-language-changed", { detail: finalLang }));
};

export const resetDefaultLanguage = (lang = DEFAULT_LANGUAGE) => {
  const isValid = SUPPORTED_LANGUAGES.some(l => l.code === lang);
  const finalLang = isValid ? lang : DEFAULT_LANGUAGE;
  if (i18n.language === finalLang) return;
  localStorage.setItem("app_language", finalLang);
  i18n.changeLanguage(finalLang);
  window.dispatchEvent(new CustomEvent("app-language-changed", { detail: finalLang }));
};

export const getCurrentLocale = () => {
  const lang = getCurrentLanguage();
  const normalized = normalizeLang(lang);
  return DATE_FNS_LOCALES[lang] || DATE_FNS_LOCALES[normalized] || DATE_FNS_LOCALES[DEFAULT_LANGUAGE];
};

export const getAntDesignDateLocale = (lang = getCurrentLanguage()) => {
  const normalized = normalizeLang(lang);
  const dayjsKey = DAYJS_LOCALE_MAP[lang] || DAYJS_LOCALE_MAP[normalized] || "en";
  dayjs.locale(dayjsKey);
  return ANT_D_LOCALES[lang] || ANT_D_LOCALES[normalized] || ANT_D_LOCALES[DEFAULT_LANGUAGE];
};